module.exports = __webpack_public_path__ + "b8c3bc16f268db16a8ef13f8a4f0bc40.svg";